import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useState } from "react";
const RechargeCommission = () => {
  const [startdate, setstartdate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [enddate, setenddate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  return (
    <>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <form id="leadFilterForm" method="post" accept-charset="utf-8">
            <div className="row">
              <div className="col-sm-4">
                <h4>
                  <b>Recharge Commision Report</b>
                </h4>
              </div>
              <div className="col-sm-2">
                <DatePicker
                  className="form-control datepick"
                  selected={startdate}
                  onChange={(date) => setstartdate(date)}
                  dateFormat="yyyy-MM-dd"
                  placeholderText={startdate}
                />
              </div>
              <div className="col-sm-2">
                {" "}
                <DatePicker
                  className="form-control datepick"
                  selected={enddate}
                  onChange={(date) => setenddate(date)}
                  dateFormat="yyyy-MM-dd"
                  placeholderText={enddate}
                />
              </div>
              <div className="col-sm-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Keyword"
                  name="keyword"
                  id="keyword"
                />
              </div>

              <div className="col-sm-2">
                <button
                  type="button"
                  className="btn btn-success"
                  id="rechargeCommisionSearchBtn"
                >
                  Search
                </button>
              </div>
            </div>
          </form>{" "}
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              id="rechargeCommisionDataTable"
              width="100%"
              cellspacing="0"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>MemberID</th>
                  <th>Name</th>
                  <th>Txn ID</th>
                  <th>Commision</th>
                  <th>Date Time</th>
                </tr>
              </thead>
              <tr>
                <th colspan="11" style={{ textAlign: "center" }}>
                  There is no data in table
                </th>
              </tr>
              <tfoot>
                <tr>
                  <th>#</th>
                  <th>MemberID</th>
                  <th>Name</th>
                  <th>Txn ID</th>
                  <th>Commision</th>
                  <th>Date Time</th>
                </tr>
              </tfoot>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
export default RechargeCommission;
